module.exports = __webpack_public_path__ + "static/szenario2_3-395d95368afb0642ce3a63909d8bd343.png";